import React from 'react';

type Props = {
  className?: string;
  color?: string;
};

/**
 * @deprecated Instead, use icons from `cb-icons`.
 */
const Comment = ({ className, color = '#202125' }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      fill={color}
      fillRule="evenodd"
      d="M21 17.5c0 .827-.673 1.5-1.5 1.5h-2a.5.5 0 0 0-.5.5v2.96l-4.188-3.351A.504.504 0 0 0 12.5 19h-8c-.827 0-1.5-.673-1.5-1.5v-13C3 3.673 3.673 3 4.5 3h15c.827 0 1.5.673 1.5 1.5v13zM19.5 2h-15A2.502 2.502 0 0 0 2 4.5v13C2 18.879 3.121 20 4.5 20h7.824l4.863 3.891a.505.505 0 0 0 .53.059.499.499 0 0 0 .283-.45V20h1.5c1.379 0 2.5-1.121 2.5-2.5v-13C22 3.121 20.879 2 19.5 2z"
    />
  </svg>
);

export default Comment;
